export default __webpack_public_path__ + "static/media/icon-home-1.61ca7403.png";